import React, { Component } from 'react';
import './VerifyDataFormOldUnused.css';

class VerifyDataForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="stepPersonalData verifyContainer">
                    <div className="stepPersonalDataTitle">Reservation information:</div>
                    <div className="col-xs-12">
                        <div><label>Service:</label></div>
                        <div className="resultDataBlock">Suuhygienistipalvelut</div>
                    </div>
                    <div className="col-xs-12">
                        <div><label>Professional:</label></div>
                        <div className="resultDataBlock">Leo Nylander</div>
                    </div>
                    <div className="col-xs-12">
                        <div><label>Date / time:</label></div>
                        <div className="resultDataBlock borderNone">
                            <div>Thursday <span>07.12.2017</span></div>
                            <div>08:45AM</div>
                        </div>
                    </div>
                </div>

                <div className="dataFormNavigation col-xs-12">
                    <div className="col-xs-6"><div className="backButton" onClick={this.props.previousStep}>Back</div></div>
                    <div className="col-xs-6"><div className="continueButton" onClick={this.props.openVerifySSNUser}>Continue</div></div>
                </div>
            </div>
        );
    }
}

export default VerifyDataForm;



// WEBPACK FOOTER //
// ./src/components/Step_4/VerifyDataFormOldUnused.jsx